export function caseInsensitiveEquals(a: string, b: string) {
    return typeof a === 'string' && typeof b === 'string'
        ? a.localeCompare(b, undefined, {sensitivity: 'accent'}) === 0
        : a === b;
}

export function camelToKebab(str: string) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function htmlToPlainText(html: string) {
    if (!html) return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    doc.querySelectorAll('br').forEach((br) => {
        br.replaceWith('\n');
    });

    const blockSelectors = 'p, div, h1, h2, h3, h4, h5, h6, li';
    doc.querySelectorAll(blockSelectors).forEach((el) => {
        el.insertAdjacentText('beforeend', '\n');
    });

    const text = doc.body.textContent || '';

    return text
        .replace(/\u00A0/g, ' ')
        .replace(/\r/g, '')
        .replace(/\n\s*\n+/g, '\n')
        .replace(/[ \t]+/g, ' ')
        .trim();
}

export function getShortDescription(str: string) {
    let text = htmlToPlainText(str);
    const lines = text.split('\n');

    if (lines.length > 2) {
        text = lines.slice(0, 2).join('\n');
    }

    return text.length > 150 ? text.slice(0, 150) : text;
}

export function showReadMore(str: string) {
    const text = htmlToPlainText(str);
    const lines = text.split('\n').length;

    return text.length > 150 || lines > 2;
}
